export const AddSiteURLValidator = (site) => [
    {
      name: "site url",
      inputName: "siteURLInput",
      value: site,
      validation: ['required'],
    }
  ]; 